<template>
  <NuxtLayout name="default">
    <template #menu>
      <div v-if="pending">
        ...
      </div>
      <p v-else-if="error">
        {{ error }}
      </p>
      <div v-else>
        <li class="menu-title">
          <span>Deine Designs</span>
        </li>
        <template v-for="design in dataSorted"
                  :key="design.id">
          <li>
            <NuxtLink :to="`/design/${design.id}`"
                      activeClass="active">
              {{ design.title }}
            </NuxtLink>
          </li>
        </template>
      </div>
    </template>
    <slot />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useNuxtApp } from "nuxt/app";
const { $surrealQuery } = useNuxtApp()

const { data, error, pending } = $surrealQuery('SELECT id, title FROM design')

const dataSorted = computed(() => {
  return data.value.sort((a, b) => a.title.localeCompare(b.title))
})

</script>
